import { Injectable } from '@angular/core';
import { safeClone } from '@client/app/shared/utils/object-utils';

@Injectable({
    providedIn: 'root',
})
export class BaseEntityService {

    updateEntryInArray (vm: any, vmKey: any, idKey: any) {
        return function (entry: any) {
            let index;
            let updatedRows;

            if (entry && !isNaN(entry[idKey]) && vm[vmKey].length) {
                index = vm[vmKey].findIndex(function (p: any) {
                    return p[idKey] === entry[idKey];
                });
                if (index != null) {
                    updatedRows = safeClone(vm[vmKey]);
                    updatedRows.splice(index, 1, entry);

                    Object.keys(vm[vmKey]).forEach(function (key: any) {
                        // Some arrays have assigned properties. That should be fixed in future.
                        if (isNaN(key)) {
                            updatedRows[key] = vm[vmKey][key];
                        }
                    });

                    vm[vmKey] = updatedRows;
                }
            }
        };
    }
}
